// 引入 axios 库，用于发送 HTTP 请求
import axios from 'axios'

// process.env.NODE_ENV定死的单词不允许自己定义 development本地开发环境 production生产环境
// 判断一下运行的环境是本地开发环境还是生产环境(发布线上),自动拼接对应的接口前缀
// 本地开发环境--本地运行,接口的前缀自动拼接接口前缀

// 这个地方根据实际情况书写，如果你本地和线上访问的后端地址不同就配置，如果本地和生产线上一个后端地址就没有必要写了

let apiBase
if (process.env.NODE_ENV == 'development') {
  // 本地开发环境
  apiBase = 'https://flwsd.com'
  // apiBase = 'https://customer1024.dongbaqu.com'
} else {
  // 生产环境
  apiBase = 'https://flwsd.com'
  // apiBase = 'https://customer1024.dongbaqu.com'
}

// 创建 axios 实例，统一配置基础路径、超时时间及默认请求头
const request = axios.create({
  baseURL: apiBase,     // 接口基础地址
  timeout: 10000,      // 请求超时时间 10 秒
  headers: {
    'Content-Type': 'application/json;charset=UTF-8' // 默认 JSON 格式及字符集
  }
})

// 请求拦截器：在每次请求发送前自动附加 token 到请求头
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token') // 从本地存储读取 token
    if (token) {
      config.headers.Authorization = `Bearer ${token}` // 若存在则添加到 Authorization 头
    }
    return config
  },
  error => Promise.reject(error) // 请求错误时直接返回拒绝的 Promise
)

// 响应拦截器：统一处理返回数据及全局错误（如 401 未授权）
request.interceptors.response.use(
  response => response.data, // 直接返回接口数据，简化调用方代码
  error => {
    if (error.response?.status === 401) {
      // 若后端返回 401，则清除本地 token 并跳转到登录页
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error) // 其他错误继续抛出，供业务层处理
  }
)

// 封装常用 RESTful 方法，方便业务层直接调用
export const get = (url, params = {}) => request.get(url, { params }) // GET 请求，参数放在 query
export const post = (url, data = {}) => request.post(url, data)       // POST 请求，数据放在 body
export const put = (url, data = {}) => request.put(url, data)       // PUT 请求，用于全量更新
export const del = (url) => request.delete(url)                       // DELETE 请求，用于删除资源

export default request
export const http = request